import { gql } from "@apollo/client";

export const GET_PARTICIPANT = gql`
  query Participant($id: ID!) {
    certParticipant(id: $id) {
      id
      firstname
      lastname
      workplace
      workplace_other
      town
      employer_type
      employer
      personal_number
      created_at
      updated_at
      course_moment {
        id
        title
        type
        start_date
        end_date
      }
    }
  }
`;

export const GET_PARTICIPANTS = gql`
  query Participants(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetParticipantsOrderByClause]
    $courseMoment: ID
  ) {
    certParticipants(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
      courseMoment: $courseMoment
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        id
        firstname
        lastname
        town
        created_at
        updated_at
        type
      }
    }
  }
`;
